import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, Ref } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  ConclusionStep,
  ContentDisplay,
  Heading,
  ListDisplay,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';

import { ICreatePortfolio } from '@/modules/catalog/services/variable-income';


export default /*#__PURE__*/_defineComponent({
  __name: 'Conclusion',
  setup(__props) {

const router = useRouter();

const conclusionData = inject('conclusionData') as Ref<ICreatePortfolio>;
const amountFormatted = inject('amountFormatted') as Ref<string>;
const amountValue = inject('amountValue') as Ref<number>;

const description = computed(() => {
  return amountValue.value > 0
    ? `Execução da carteira prevista para ${conclusionData.value.expectedInvestmentDate}`
    : '';
});

const details = computed(() => {
  return [
    {
      label: 'Nome',
      value: conclusionData.value.portfolioName,
      canShow: true
    },
    {
      label: 'Total investido',
      value: `R$ ${amountFormatted.value}`,
      canShow: amountValue.value > 0
    },
    {
      label: 'Tipo de gestão',
      value: 'Warren',
      canShow: true
    }
  ];
});

function goToPortfolio() {
  router.push({
    name: 'wealthIndexPortfolio',
    params: { portfolioId: conclusionData.value.portfolioId }
  });
}

return { __sfc: true,router, conclusionData, amountFormatted, amountValue, description, details, goToPortfolio, ConclusionStep, ContentDisplay, Heading, ListDisplay, ButtonPrimary }
}

})